import Vue from 'vue'
import Router from 'vue-router'

import Welcome from '@/pages/Welcome'
import Results from '@/pages/Results'
import Scenarios from '@/pages/Scenarios'
import Interventions from '@/pages/Interventions'
import InterventionsHistory from '@/pages/InterventionsHistory'
import Lessons from '@/pages/Lessons'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome,
    },
    {
      path: '/scenarios',
      name: 'Scenarios',
      component: Scenarios,
    },
    {
      path: '/interventions-history',
      name: 'Interventions History',
      component: InterventionsHistory,
    },
    {
      path: '/interventions',
      name: 'Interventions',
      component: Interventions,
    },
    {
      path: '/results',
      name: 'Results',
      component: Results,
    },
    {
      path: '/lessons',
      name: 'Lessons',
      component: Lessons,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})
